import { clone } from "lodash";

// 2.7.94 WSProductDisplay
export default class WSMediaRestriction {
	constructor({
		mediaRestrictionId = null,
		mediaRestrictionName = null,
	}) {
		/**
		 * int
		 * (Required) Indicates the group number for grouping
		 * the products for display.
		 */
		this.mediaRestrictionId = mediaRestrictionId;

		/**
		 * int
		 * (Required) Order to display the product within its
		 * group.
		 */
		this.mediaRestrictionName = mediaRestrictionName;
	}

	static fromBackoffice(data) {
		const result = new WSMediaRestriction(data);

		return result;
	}

	static fromSerialized(data) {
		const result = new WSMediaRestriction(data);

		return result;
	}

	toBackoffice() {
		const result = clone(this);

		return result;
	}

	toResolver() {
		const forGraphql = clone(this);

		forGraphql.id = this.IDPROP;

		return forGraphql;
	}
}

export const WSMediaRestrictionType = [ `
		type WSMediaRestriction {
			mediaRestrictionId: Int
			mediaRestrictionName: String
		}
	`,
];
